import { RootState } from 'app/store'
import { IModal } from './modalsSlice'

export const selectModals = (state: RootState): Array<IModal> => state.modals
